import { PlacementDocumentItem } from '@/api/placementApi.schemas';
import { DOCUMENTS } from '@/enums/documents';

interface UseFilteredDocumentsParams {
  documents?: PlacementDocumentItem[] | null | undefined;
}

interface UseFilteredDocumentsReturn {
  exPostDocuments: PlacementDocumentItem[];
  regularDocuments: PlacementDocumentItem[];
  getDocumentsByType: (typeDocument: string) => PlacementDocumentItem[];
}

export const useFilteredDocuments = ({ documents }: UseFilteredDocumentsParams): UseFilteredDocumentsReturn => {
  const exPostDocuments = documents?.filter((document) => document.typeDocument === DOCUMENTS.REPORT_EXPOST) || [];

  const regularDocuments =
    documents?.filter((document) => document.typeDocument === DOCUMENTS.REPORT_REGULAR_ADVISORY) || [];

  const getDocumentsByType = (typeDocument: string) => {
    return documents?.filter((document) => document.typeDocument === typeDocument) || [];
  };

  return {
    exPostDocuments,
    regularDocuments,
    getDocumentsByType,
  };
};
